<template>
  <div>
    <section style="padding: 50px" class="pdf-item">
      <!-- Main -->
      <div v-if="pageTitle === 'Main'">
        <a-row class="mb-20 ml-20" style="text-align: left">
          <a-col v-if="!['', null, 'null'].includes(dataProfile[0].file_img)">
            <img style="width: 120px; height: 120px" :src="dataProfile[0].file_img" alt="User Image" ref="userImage" />
          </a-col>
        </a-row>
        <table class="table">
          <thead>
            <tr>
              <th scope="col">
                <h4>{{ pageTitle }}</h4>
              </th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">{{ dataProfile[0].file_img }} Name-Surname</th>
              <td style="font-size: 12px">
                <div v-if="dataProfile[0].name_detail.length != 0">
                  <span class="font-s-16">
                    {{
                      `${checkBlank(
                        dataProfile[0].name_detail[0].eng_first_name
                      )} ${checkBlank(
                        dataProfile[0].name_detail[0].eng_middle_name
                      )} ${checkBlank(
                        dataProfile[0].name_detail[0].eng_last_name
                      )}`
                    }}
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">ชื่อ-นามสกุล</th>
              <td style="font-size: 12px">
                <div v-if="dataProfile[0].name_detail.length != 0">
                  <span class="font-s-16">
                    {{
                      `${checkBlank(
                        dataProfile[0].name_detail[0].thai_first_name
                      )} ${checkBlank(
                        dataProfile[0].name_detail[0].thai_middle_name
                      )} ${checkBlank(
                        dataProfile[0].name_detail[0].thai_last_name
                      )}`
                    }}
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">MUICAA Member</th>
              <td>
                <span>{{ checkBlank(dataProfile[0].muicaa_member) }}</span>
              </td>
            </tr>
            <tr>
              <th scope="row">Student ID</th>
              <td>
                <span>{{ checkBlank(dataProfile[0].student_id) }}</span>
              </td>
            </tr>
            <tr>
              <th scope="row">Major</th>
              <td>
                <span v-if="checkObjNull(dataProfile[0].major_detail)">
                {{ 
                checkBlank(dataProfile[0].major_detail.name_eng)
                }}
                  <!-- {{ checkBlank(dataProfile[0].major_detail.name_thai) }} -->
                </span>
              </td>
            </tr>
            <tr>
              <th scope="row">Graduate Year</th>
              <td>
                <span v-if="dataProfile[0].graduate_date">{{
                  moment(dataProfile[0].graduate_date).format("YYYY")
                }}</span>
              </td>
            </tr>
            <tr>
              <th scope="row">Graduate Date</th>
              <td>
                <span v-if="dataProfile[0].graduate_date">{{
                  moment(dataProfile[0].graduate_date).format(
                    "DD / MMMM / YYYY"
                  )
                }}</span>
              </td>
            </tr>
            <tr>
              <th scope="row">Graduate Status</th>
              <td v-if="checkObjNull(dataProfile[0].graduate_status_detail)">
                <b>GPA</b> : {{ checkBlank(dataProfile[0].grade) }}<br />
                <span>{{
                  `${checkBlank(
                    dataProfile[0].graduate_status_detail.name_eng
                  )} ${checkBlank(
                    dataProfile[0].graduate_status_detail.name_thai
                  )}`
                }}</span>
              </td>
            </tr> 
            <tr>
              <th scope="row">Contact</th>
              <td>
                <div v-if="dataProfile[0].contact_detail.length != 0">
                  <span>
                    <b>Email</b> :
                    {{ checkBlank(dataProfile[0].contact_detail[0].email)
                    }}<br />
                    <b>Phone</b> :
                    {{
                      checkBlank(dataProfile[0].contact_detail[0].phone_number)
                    }}<br />
                    <b>Address</b> :
                    {{ checkBlank(dataProfile[0].contact_detail[0].address)
                    }}<br />
                    <b>Facebook</b> :
                    {{
                      checkBlank(
                        dataProfile[0].contact_detail[0].social_facebook
                      )
                    }}<br />
                    <b>Instagram</b> :
                    {{
                      checkBlank(
                        dataProfile[0].contact_detail[0].social_instagram
                      )
                    }}<br />
                    <b>Line</b> :
                    {{ checkBlank(dataProfile[0].contact_detail[0].social_line)
                    }}<br />
                    <span style="font-size: 10px"
                      >Update at:
                      {{
                        moment(
                          dataProfile[0].contact_detail[0].created_at
                        ).format("DD/MM/YYYY HH:mm:ss")
                      }}
                    </span>
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">Work</th>
              <td>
                <div v-if="dataProfile[0].work_detail.length != 0">
                  <span>
                    <!-- <pre>{{ listWork() }}</pre> -->
                    <!-- <b>Family owned business</b> :
                    {{ checkBlank(listWork().family_owned_business) }}<br /> -->
                    <b>Position</b> : {{ checkBlank(listWork().position_name)
                    }}<br />
                    <b>Company name</b> :
                    {{ checkBlank(listWork().company_name) }}<br />
                    <!-- <b>Work date</b> :
                    {{ `${listWork().start_work} - ${listWork().end_work}` }}
                    <br />
                    <span style="font-size: 10px"
                      >Update at:
                      {{
                        moment(listWork().created_at).format(
                          "DD/MM/YYYY HH:mm:ss"
                        )
                      }}
                    </span> -->
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
      </div>
      <!-- Background -->
      <div v-if="pageTitle === 'Background'">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">
                <h4>{{ pageTitle }}</h4>
              </th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">Student ID</th>
              <td style="font-size: 12px">
                <span>{{ checkBlank(dataProfile[0].student_id) }}</span>
              </td>
            </tr>
            <tr>
              <th scope="row">Membership ID</th>
              <td style="font-size: 12px">
                <span>
                  {{ checkBlank(dataProfile[0].membership_id) }}</span>
              </td>
            </tr>
            <tr>
              <th scope="row">MUICAA Alumni Committee</th>
              <td style="font-size: 12px">
                <span>{{ checkBlank(dataProfile[0].muicaa_member) }}</span>
              </td>
            </tr>
            <tr>
              <th scope="row">Nationality</th>
              <td style="font-size: 12px">
                <span v-if="checkObjNull(dataProfile[0].nationality_detetail)">{{
                  `${checkBlank(
                    dataProfile[0].nationality_detetail.name_eng
                  )}`
                }}</span>
              </td>
            </tr>
            <tr>
              <th scope="row">History name</th>
              <td>
                <div v-for="(listname, index) in dataProfile[0].name_detail" :key="'listn' + index">
                  <a-row>
                    <a-col style="text-align: right">
                      <span style="font-size: 10px">Update at:
                        {{
                          moment(listname.created_at).format(
                            "DD/MM/YYYY HH:mm:ss"
                          )
                        }}
                      </span>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col>
                      <span style="font-size: 12px"><b>Title:</b>
                        {{
                          `${listname.title_name_detail
                            ? listname.title_name_detail.name_eng
                            : ""
                          }`
                        }}
                      </span>
                    </a-col>
                  </a-row>
                  <a-row v-if="listname.academic_title">
                    <a-col>
                      <span style="font-size: 12px"><b>Academic Title:</b>
                        {{
                          `${listname.academic_title_detail
                            ? listname.academic_title_detail.name_eng
                            : ""
                          }`
                        }}
                      </span>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col>
                      <span style="font-size: 12px"><b>[EN]:</b>
                        {{
                          `${checkBlank(listname.eng_first_name)} ${checkBlank(
                            listname.eng_middle_name
                          )} ${checkBlank(listname.eng_last_name)}`
                        }}
                      </span>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col>
                      <span style="font-size: 12px"><b>[TH]:</b>
                        {{
                          `${checkBlank(listname.thai_first_name)} ${checkBlank(
                            listname.thai_middle_name
                          )} ${checkBlank(listname.thai_last_name)}`
                        }}
                      </span>
                    </a-col>
                  </a-row>
                  <hr />
                </div>
              </td>
            </tr>
           <tr>
              <th scope="row">Nationality</th>
              <td>
                <span v-if="checkObjNull(dataProfile[0].nationality_detetail)">{{
                  checkBlank(dataProfile[0].nationality_detetail.name_eng)
                }}</span>
              </td>
            </tr>
            <tr>
              <th scope="row">Major</th>
              <td>
                <span v-if="checkObjNull(dataProfile[0].major_detail)">{{
                  checkBlank(dataProfile[0].major_detail.name_eng)
                }}</span>
              </td>
            </tr>
            <tr>
              <th scope="row">Minor</th>
              <td>
                <span>{{ checkBlank(dataProfile[0].minor) }} </span>
              </td>
            </tr>
            <tr>
              <th scope="row">Concentration</th>
              <td>
                <span>{{ checkBlank(dataProfile[0].concentration) }} </span>
              </td>
            </tr>
            <tr>
              <th scope="row">Date of Graduation</th>
              <td>
                <span v-if="checkObjNull(dataProfile[0].graduate_date)">
                  {{
                    moment(dataProfile[0].graduate_date).format("DD/MM/YYYY")
                  }}
                </span>
              </td>
            </tr>
            <tr>
              <th scope="row">G.P.A</th>
              <td>
                <span v-if="dataProfile[0].grade">{{ dataProfile[0].grade }}
                </span>
              </td>
            </tr>
            <tr>
              <th scope="row">Graduate Status</th>
              <td>
                <span>{{ checkBlank(dataProfile[0].graduate_status_detail) }}
                </span>
              </td>
            </tr> 
          </tbody>
        </table>
      </div>
      <!-- Contact -->
      <div v-if="pageTitle === 'Contact'">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">
                <h4>{{ pageTitle }}</h4>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(listcontact, index) in dataProfile[0].contact_detail" :key="'listc' + index">
              <td>
                <a-row>
                  <a-col style="text-align: right">
                    <span style="font-size: 10px">Update at:
                      {{
                        moment(listcontact.created_at).format(
                          "DD/MM/YYYY HH:mm:ss"
                        )
                      }}
                    </span>
                  </a-col>
                </a-row>
                <b>Address</b> : {{ checkBlank(listcontact.address) }}<br />
                <b>Email</b> : {{ checkBlank(listcontact.email) }}<br />
                <b>Mobile Phone</b> : {{ checkBlank(listcontact.phone_number)
                }}<br />
                <b>Facebook</b> : {{ checkBlank(listcontact.social_facebook)
                }}<br />
                <b>Instagram</b> : {{ checkBlank(listcontact.social_instagram)
                }}<br />
              </td>
            </tr>
            <hr />
          </tbody>
        </table>
      </div>
      <!-- Futher Education -->
      <div v-if="pageTitle === 'Futher Education'">
        <table class="table" style="width: 100%">
          <thead>
            <tr>
              <th scope="col">
                <h4>{{ pageTitle }}</h4>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(listedu, index) in dataProfile[0].education_detail" :key="'liste' + index">
              <td>
                <span>
                  <a-row>
                    <a-col style="text-align: right">
                      <span style="font-size: 10px">Update at:
                        {{
                          moment(listedu.created_at).format(
                            "DD/MM/YYYY HH:mm:ss"
                          )
                        }}
                      </span>
                    </a-col>
                  </a-row>
                  <b>Name of University</b> :
                  {{ checkBlank(listedu.university_name) }}<br />
                  <b>Major</b> : {{ checkBlank(listedu.major) }}<br />
                  <b>Degree</b> :
                  {{
                    listedu.type_graduate_detail
                    ? listedu.type_graduate_detail.name_eng
                    : ""
                  }}<br />
                  <b>Country</b> :
                  {{
                    listedu.country_detail
                    ? listedu.country_detail.name_eng
                    : ""
                  }}<br />
                </span>
                <hr />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- Work Experience -->
      <div v-if="pageTitle === 'Work Experience'">
        <table class="table" style="width: 100%">
          <thead>
            <tr>
              <th scope="col">
                <h4>{{ pageTitle }}</h4>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(listwork, index) in dataProfile[0].work_detail
              .slice()
              .reverse()" :key="'listw' + index">
              <td>
                <span>
                  <a-row>
                    <a-col style="text-align: right">
                      <span style="font-size: 10px">Update at:
                        {{
                          moment(listwork.created_at).format(
                            "DD/MM/YYYY HH:mm:ss"
                          )
                        }}
                      </span>
                    </a-col>
                  </a-row>
                  <b>Position</b> : {{ checkBlank(listwork.position_name)
                  }}<br />
                  <b>Company name</b> : {{ checkBlank(listwork.company_name)
                  }}<br />
                  <b>Job Sector</b> :
                  {{
                    listwork.job_sector_detail
                    ? listwork.job_sector_detail.name_eng
                    : ""
                  }}<br />
                </span>
                <hr />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- Achievements -->
      <div v-if="pageTitle === 'Achievements'">
        <table class="table" style="width: 100%">
          <thead>
            <tr>
              <th scope="col">
                <h4>{{ pageTitle }}</h4>
              </th>
            </tr>
          </thead>
          <tbody>
            <!-- <tr>{{ dataAchievment }}</tr> -->
            <tr v-for="(lista, index) in dataAchievment.slice().reverse()" :key="'listaw' + index">
              <td>
                <span>
                  <a-row>
                    <a-col style="text-align: right">
                      <span style="font-size: 10px">Update at:
                        {{
                          moment(lista.created_at).format("DD/MM/YYYY HH:mm:ss")
                        }}
                      </span>
                    </a-col>
                  </a-row>
                  <b>Name of Award/Scholarship</b> :
                  {{ checkBlank(lista.name_of_award_scholarship) }}<br />
                  <b>Date of Receive</b> :
                  {{ moment(lista.date_of_recive).format("DD/MM/YYYY") }}<br />
                  <b>Organized by/Granted By</b> :
                  {{ checkBlank(lista.organized_by_granted_by) }}<br />
                  <b>Location</b> : {{ checkBlank(lista.location_and_country)
                  }}<br />
                  <b>Type of Award</b> : {{ checkBlank(lista.type_award)
                  }}<br />
                </span>
                <hr />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Engagement -->
      <div v-if="pageTitle === 'Engagements'">
        <table class="table" style="width: 100%">
          <thead>
            <tr>
              <th scope="col">
                <h4>{{ pageTitle }}</h4>
              </th>
            </tr>
          </thead>
          <tbody>
            <!-- <tr>{{ dataEngagement }}</tr> -->
            <tr v-for="(item, index) in dataEngagement.slice().reverse()" :key="'listaw' + index">
              <td>
                <span>
                  <a-row>
                    <a-col style="text-align: right">
                      <span style="font-size: 10px">Update at:
                        {{
                          moment(item.created_at).format("DD/MM/YYYY HH:mm:ss")
                        }}
                      </span>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col class="text-center" :span="20">
                      <a-row>
                        <a-col :span="5">
                          <b class="mt-5 mb-0">Activity Name : </b>
                        </a-col>
                        <a-col :span="12">
                          <p class="mt-5 mb-0">{{ item.engement_activity_detail ?
                            item.engement_activity_detail.name_of_activity : '' }}</p>
                        </a-col>
                      </a-row>
                      <a-row class="mt-10">
                        <a-col :span="5">
                          <b class="mt-5 mb-0">Date of Activity : </b>
                        </a-col>
                        <a-col :span="12">
                          <p class="mt-5 mb-0">{{ item.engement_activity_detail ?
                            item.engement_activity_detail.date_of_activity : '' }}</p>
                        </a-col>
                      </a-row>
                      <a-row class="mt-10">
                        <a-col :span="5">
                          <b class="mt-5 mb-0">Role and Duty in the activity : </b>
                        </a-col>
                        <a-col :span="12">
                          <p class="mt-5 mb-0">{{
                            item.role_and_duty_in_the_activity_detail ? item.role_and_duty_in_the_activity_detail.name_eng
                            :
                            item.role_and_duty_in_the_activity_other }}</p>
                        </a-col>
                      </a-row>

                      <a-row class="mt-10">
                        <a-col :span="5">
                          <b class="mt-5 mb-0">Donation : </b>
                        </a-col>
                        <a-col :span="12">
                          <div class="mt-5 mb-0">
                            <span>
                              Charity : {{ item.amount_charity }}
                            </span><br />
                            <span>
                              Fee : {{ item.amount_fee }}
                            </span><br />
                            <span>
                              Sponsorship : {{ item.amount_sponsorship }}
                            </span>
                          </div>
                        </a-col>
                      </a-row>

                      <a-row class="mt-10">
                        <a-col :span="5">
                          <b class="mt-5 mb-0">Items : </b>
                        </a-col>
                        <a-col :span="12">
                          <span class="mt-5 mb-0" v-for="(item, index) in item.item_detail" :key="index"
                            :value="item.value">
                            {{ item.item_detail + " " + item.amount }}
                            {{ index != item.item_detail.length - 1 ? "," : "" }}
                          </span>
                        </a-col>
                      </a-row>

                      <a-row class="mt-10">
                        <a-col :span="5">
                          <b class="mt-5 mb-0">Organized by : </b>
                        </a-col>
                        <a-col :span="12">
                          <p class="mt-5 mb-0">{{ item.engement_activity_detail ?
                            item.engement_activity_detail.organized_by : '' }}</p>
                        </a-col>
                      </a-row>

                      <a-row class="mt-10">
                        <a-col :span="5">
                          <b class="mt-5 mb-0">Location : </b>
                        </a-col>
                        <a-col :span="12">
                          <p class="mt-5 mb-0">{{ item.engement_activity_detail ? item.engement_activity_detail.location :
                            '' }}</p>
                        </a-col>
                      </a-row>
                    </a-col>

                  </a-row>
                </span>
                <hr />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    pageTitle: {
      type: String,
      default: () => "",
    },
    dataProfile: {
      type: Array,
      default: () => [],
    },
    dataAchievment: {
      type: Array,
      default: () => [],
    },
    dataEngagement: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  methods: {
    checkBlank(val) {
      return !["", "null", null].includes(val) ? val : "";
    },
    checkObjNull(objCheck) {
      return objCheck?Object.keys(objCheck).length != 0:false //
    },
    listWork() {
      if (this.dataProfile[0].work_detail.length != 0) {
        return this.dataProfile[0].work_detail.slice().reverse()[0];
      }
    },
  },
};
</script>

<style scoped>
table,
th,
td {
  border: 0px solid;
  height: 30px;
}

th {
  width: 40%;
}

td {
  padding: 5px;
  width: 60%;
}

.font-s-16 {
  font-size: 16px;
}
</style>